<a
  class="link"
  *ngIf="inline; else blockButton"
  [attr.href]="href"
  [attr.target]="openInNewTab ? '_blank' : null"
  i2gTrackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
>
  <span class="inline-link-content">
    <i2g-icon *ngIf="icon" class="link-icon" [icon]="icon"> </i2g-icon>

    <span *ngIf="label" class="label">
      {{ label }}
    </span>
  </span>
</a>

<ng-template #blockButton>
  <a
    class="link"
    [attr.href]="href"
    [attr.target]="openInNewTab ? '_blank' : null"
    i2gButton
    [buttonStyle]="buttonStyle"
    i2gTrackable
    [trackingObject]="trackingObject"
    [trackingAction]="trackingAction"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
  >
    <span class="block-link-content">
      <i2g-icon *ngIf="icon" class="link-icon" [icon]="icon"> </i2g-icon>

      <span *ngIf="label" class="label">
        {{ label }}
      </span>
    </span>
  </a>
</ng-template>
